/* 曹操傳・第 6 章／劉備傳・第 3 章：下邳（196、198 年）
 * 下邳城在東南的低地；北邊是泗水、東北是沂水，河堤各在上游一處。西邊是曹營所在的高地，西北也有一塊高丘。 */
export const CITY = { x: 5800, y: 3300, hw: 800, hh: 560 };
const T = 36, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATE = [Wx, CITY.y], DIKES = [[3200, 1150], [7000, 1350]], CAMP = [1500, 3100], HILLS = [[1500, 3100, 1000, 700], [2900, 1900, 420, 300]];
export default {
  id: 'xiapi', name: '下邳', W: 8600, H: 5200, seed: 198,
  bases: [CAMP, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], [E, CITY.y, T, CITY.hh], [Wx, (N + CITY.y - 130) / 2, T, (CITY.y - 130 - N) / 2], [Wx, (S + CITY.y + 130) / 2, T, (S - CITY.y - 130) / 2]],
  rivers: [{ pts: [[-100, 900], [2000, 950], [3200, 900], [5000, 980], [8700, 1000]], hw: 170, fords: [] }],
  roads: [
    { pts: [CAMP, [2800, 3200], [4200, 3300], GATE, [CITY.x, CITY.y]], w: 150 },
    { pts: [[2800, 3200], [3000, 2200], [DIKES[0][0], DIKES[0][1] + 120]], w: 110 },
    { pts: [[4200, 3300], [5600, 2200], [DIKES[1][0], DIKES[1][1] + 120]], w: 110 },
  ],
  rocks: [[1100, 2300, 300, 160], [2000, 4200, 360, 170], [4300, 4500, 360, 170], [7600, 4300, 380, 180]],
  woods: 0.35,
  sight: 0.8,
  clearings: [[CAMP[0], CAMP[1], 600], [CITY.x, CITY.y, 900], [DIKES[0][0], DIKES[0][1] + 150, 300], [DIKES[1][0], DIKES[1][1] + 150, 300], [GATE[0] - 400, GATE[1], 400]],
  villages: [{ x: CITY.x, y: CITY.y, n: 10, r: 520 }],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 8, r: 460, chief: true, col: '#3b5a99', flag: '曹' }],
  fields: [[4000, 2600, 600, 300], [4600, 4000, 560, 280, '#86803f']],
  grass: [[3400, 2600, 240, 110], [4500, 3800, 260, 120], [5200, 2000, 240, 110], [6200, 4300, 260, 110], [7000, 3000, 260, 120], [7600, 2200, 220, 100]], // 劉備傳第 3 章：撤往海西時躲騎兵
};
